import { createFileRoute } from '@tanstack/react-router';
import { WorkflowManager } from '~/components/workflow/WorkflowManager';

export const Route = createFileRoute('/_app/admin/workflows')({
  component: WorkflowsPage,
});

function WorkflowsPage() {
  return (
    <div className="px-6 py-6 max-w-[1400px] mx-auto">
      <h1 className="font-display text-3xl font-bold text-[var(--color-navy)]">Compliance Workflows</h1>
      <p className="text-sm text-[var(--color-ink-soft)] mt-1 mb-6">
        Also configurable in <span className="font-semibold">Playbook → Compliance Task Workflow</span>.
      </p>
      <WorkflowManager showHeading={false} />
    </div>
  );
}
